import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import {
  type IMapLayerSource,
  type IMapLayerWfsOptions,
  type MapLayerType,
} from '../layers/MapLayer.ts';

/**
 * Osserva nel form la fonte dati del layer al prefix indicato (tipo,
 * URL e opzioni protocollo-specifiche) e la restituisce come
 * `IMapLayerSource`.
 *
 * È l'unico punto della config UI che enumera i campi per-protocollo:
 * un nuovo protocollo aggiunge qui il proprio watch e la config fluisce
 * a introspezione e verifica del tipo di servizio.
 */
export function useWatchedMapLayerSource(layerPrefix: string): IMapLayerSource {
  const url: string | undefined = useWatch({ name: `${layerPrefix}url` });
  const type: MapLayerType | undefined = useWatch({
    name: `${layerPrefix}type`,
  });
  const wfs: IMapLayerWfsOptions | undefined = useWatch({
    name: `${layerPrefix}wfs`,
  });

  return useMemo(() => ({ url, type, wfs }), [url, type, wfs]);
}
